import { IInvoiceListItem } from '../types';

export enum InvoicesActionType {
    GET_INVOICES_DATA = 'GET_INVOICES_DATA',
}

interface GetInvoicesActionType {
    type: InvoicesActionType.GET_INVOICES_DATA;
    payload: Array<IInvoiceListItem>;
}

export type InvoicesAction = GetInvoicesActionType;
